import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import '../../styles/CardsPromotionSelector.css';

/** UI aislada: no modifica el importe ni la validación de inicial. */
export default function CardsPromotionSelector({open, saleType, eligible, onChange, apiBase}) {
  const [rows,setRows]=useState([]);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  const [enabled,setEnabled]=useState(false);
  const [selections,setSelections]=useState(['', '', '', '']);
  useEffect(()=>{
    if(!open || !eligible){setRows([]);setEnabled(false);setSelections(['', '', '', '']);onChange([]);return;}
    let cancelled=false;
    setLoading(true);setError('');setEnabled(false);setSelections(['', '', '', '']);onChange([]);
    axios.get(`${apiBase}/promotions/eligible`,{params:{saleType: ['cash','contado','2'].includes(String(saleType).toLowerCase()) ? 'cash' : 'credit'},headers:{Authorization:`Bearer ${localStorage.getItem('token')}`}})
      .then(r=>{if(!cancelled)setRows(Array.isArray(r.data?.data)?r.data.data:[]);})
      .catch(()=>{if(!cancelled){setError('No se pudo consultar los obsequios.');setRows([]);}})
      .finally(()=>{if(!cancelled)setLoading(false);});
    return ()=>{cancelled=true;};
  },[open,eligible,saleType,apiBase]); // onChange estable desde padre
  const options=useMemo(()=>rows.filter(x=>Number(x.available)>0),[rows]);
  useEffect(()=>{
    const selected=enabled?selections.filter(Boolean).map(key=>options.find(x=>`${x.promotion_id}:${x.product_id}:${x.location_id}`===key)).filter(Boolean):[];
    onChange(selected.map(x=>({promotion_id:Number(x.promotion_id),product_id:Number(x.product_id),location_id:Number(x.location_id),quantity:1})));
  },[enabled,selections,options,onChange]);
  if(!eligible)return null;
  const renderOption=x=><option key={`${x.promotion_id}:${x.product_id}:${x.location_id}`} value={`${x.promotion_id}:${x.product_id}:${x.location_id}`}>{x.title} · {x.category} · Stock: {x.available}</option>;
  return <section className="cardsPromo" aria-label="Obsequios promocionales">
    <div className="cardsPromo__heading"><strong>🎁 OBSEQUIOS PROMOCIONALES</strong><span>Opcional · S/ 0.00</span></div>
    {loading?<p>Consultando promociones vigentes…</p>:error?<p role="alert">{error}</p>:options.length===0?<p>No hay obsequios con stock disponible en esta sede para la modalidad seleccionada.</p>:<>
      <label className="cardsPromo__toggle"><input type="checkbox" checked={enabled} onChange={e=>setEnabled(e.target.checked)}/> Agregar obsequios a esta venta</label>
      {enabled&&<div className="cardsPromo__fields">
        {['Primer', 'Segundo', 'Tercer', 'Cuarto'].map((ordinal, index) => (
          <label key={ordinal}>{ordinal} obsequio {index > 0 ? '(opcional)' : ''}
            <select value={selections[index]} onChange={e => setSelections(previous => {
              const next = [...previous];
              next[index] = e.target.value;
              return next;
            })}>
              <option value="">{index === 0 ? 'Seleccionar obsequio' : `Sin ${ordinal.toLowerCase()} obsequio`}</option>
              {options.filter(x => {
                const key = `${x.promotion_id}:${x.product_id}:${x.location_id}`;
                return !selections.some((selected, position) => position !== index && selected === key);
              }).map(renderOption)}
            </select>
          </label>
        ))}
        {!selections[0]&&<small>Selecciona al menos un obsequio para continuar.</small>}
        <small>Máximo 4 obsequios por celular. La disponibilidad se validará nuevamente al guardar.</small>
      </div>}
    </>}
  </section>;
}
